import { gql } from '@apollo/client'

export const USERS_LIST_QUERY = gql`
  query Users($filters: UsersFilters) {
    users(filters: $filters) {
      users {
        ID
        name
        email
        role
        entityName
        entityCode
        displayEntityCode
        entityID
        active
      }
      pagination {
        page
        perPage
        total
      }
    }
  }
`

export const USER_QUERY = gql`
  query User($userID: String!) {
    user(userID: $userID) {
      ID
      name
      username
      email
      phoneNumber
      lastLogin
      roleID
      displayRoleID
      entityType
      entityID
      entityCode
      entityName
      active
      activeUntil
      locked
      unlockesIn
      failedAttempts
      resources {
        entityId
        entityCode
        displayEntityCode
        entityType
        entityName
      }
      regionalSettings {
        languagesAvailable
        currenciesAvailable
        defaultCurrency
        timezone
        theme
        themeCode
      }
      twoFactorEnabled
    }
  }
`

export const GENERATE_USER_MUTATION = gql`
  mutation GenerateUser($input: GenerateUserInput!) {
    generateUser(input: $input) {
      message
    }
  }
`

export const MODIFY_USER_MUTATION = gql`
  mutation ModifyUser($userID: String!, $input: ModifyUserInput!) {
    modifyUser(userID: $userID, input: $input) {
      message
    }
  }
`

export const USER_BULK_ACCESS_MUTATION = gql`
  mutation UserBulkAccess($input: UserBulkAccessInput!) {
    userBulkAccess(input: $input) {
      message
    }
  }
`

export const ACCESS_MANAGEMENT_JOB_HANDLER_SUBSCRIPTION = gql`
  subscription AccessManagementJobHandler($trackingID: String!) {
    AccessManagementJobHandler(trackingID: $trackingID) {
      status
      email
    }
  }
`

export const UNLOCK_USER_MURATION = gql`
  mutation unlockUser($userID: String!) {
    unlockUser(userID: $userID) {
      message
    }
  }
`
